import { render, staticRenderFns } from "./SignUpDone.vue?vue&type=template&id=1f71800e&scoped=true&lang=pug"
import script from "./SignUpDone.vue?vue&type=script&lang=js"
export * from "./SignUpDone.vue?vue&type=script&lang=js"
import style0 from "./SignUpDone.vue?vue&type=style&index=0&id=1f71800e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71800e",
  null
  
)

export default component.exports